import * as React from 'react';
// import { withRouter } from "react-router-dom";
// import { RouteComponentProps } from "react-router-dom";
import {
    Theme,
    createStyles,
} from '@mui/material';
import { Fastfood } from '@mui/icons-material';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import CardMedia from "@mui/material/CardMedia";
import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
const styles = (theme: Theme) => createStyles({
    acronym: {
        display: 'inline-block',
        textAlign: 'center',
        fontSize: '30px',
        fontWeight: 'bold',
        color: '#FFF',
    },
    acronymOverlay: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#fff',
        alignItems: 'center',
        width: '95%'
    },
    acronymOverlayGray: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        border: '1px solid gray',
        borderRadius: '16px 16px 0px 0px',
        alignItems: 'center',
    },
    imgContainer: {
        position: "relative",
    },
    leftArrowBtn: {
        position: "absolute",
        left: "15px",
        top: "50%",
        color: "white",
        transform: 'translate(-50%, -50%)'
    },
    rightArrowBtn: {
        position: "absolute",
        right: "-23px",
        top: "50%",
        color: "white",
        transform: 'translate(-50%, -50%)'
    },
});
interface MatchParams {
    id: string
}
interface IPageProps {
    classes: any;
    name: string;
    imageUrl: string;
    imageUrl2?: string;
    imageUrl3?: string;
    imageUrl4?: string;
    imageUrl5?: string;
    reorderVersion?: boolean;
    bgColor?: string;
    className?: string;
    organizationSettings: any
    menuCategories: any
}



class ImgPlaceholder extends React.Component<IPageProps & {}> {
     state = {
        currentImageIndex: 0,
    };

        handleLeftClick = (event?: React.MouseEvent) => {
    if (event) event.stopPropagation();
    this.setState((prevState: any) => ({
        currentImageIndex: Math.max(prevState.currentImageIndex - 1, 0),
    }));
    };

    handleRightClick = (imagesLength: number, event?: React.MouseEvent) => {
    if (event) event.stopPropagation();
    this.setState((prevState: any) => ({
        currentImageIndex: Math.min(prevState.currentImageIndex + 1, imagesLength - 1),
    }));
    };

    public render() {
        const { classes, name, bgColor, className, imageUrl,imageUrl2, imageUrl3, imageUrl4, imageUrl5, organizationSettings, reorderVersion } = this.props;
         const { currentImageIndex } = this.state;


        if(organizationSettings?.layoutVariant === "Imageless"){
            return null
        }

        const imageUrls = [imageUrl, imageUrl2, imageUrl3, imageUrl4, imageUrl5].filter(Boolean);
        const imagesLength = imageUrls.length;

        return (
            imagesLength > 0 ?
                <div className={classes.imgContainer}>

                    {imagesLength > 1 && currentImageIndex > 0 && (
                        <ChevronLeftOutlinedIcon
                            className={classes.leftArrowBtn}
                            sx={{ color: organizationSettings?.layoutColor }}
                            onClick={(e) => this.handleLeftClick(e)}
                            style={{ cursor: 'pointer', zIndex: 2 }}
                        />
                    )}  
                    <CardMedia
                        className={className ? className : ''}
                        image={imageUrls[currentImageIndex]}
                        title={name}
                    />
                    {imagesLength > 1 && currentImageIndex < imagesLength - 1 && (
                        <ChevronRightOutlinedIcon
                            className={classes.rightArrowBtn}
                            sx={{ color: organizationSettings?.layoutColor }}
                             onClick={(e) => this.handleRightClick(imagesLength, e)}
                            style={{ cursor: 'pointer', zIndex: 2 }}
                        />
                    )}
                </div>
                :
                <span className={`${className} ${classes.acronym}`} style={{
                    backgroundColor: bgColor ? bgColor : '#eee',
                    height: reorderVersion ? '75px':'100%',
                    width: reorderVersion ? '65px': '100%',
                    padding: 0,
                }}
                >
                    <span className={`${className} ${bgColor ? classes.acronymOverlay : classes.acronymOverlayGray}`} style={{
                        height: (reorderVersion ? '75px': bgColor ? '94%' : '325px'),
                        width: (reorderVersion ? '65px': bgColor ? '94%' : 'auto'),
                        margin: (reorderVersion ? '0' : bgColor ? '3%' : '0'),
                        padding: 0,
                        borderRadius: reorderVersion ? '6px' : '16px 16px 0px 0px'
                    }}
                    >
                        <Fastfood sx={{
                            textAlign: 'center',
                            width: '100%',
                            color: '#aaa',
                            fontSize: { xs: 'medium' },
                            height: { xs: '60%' },
                            borderRadius: '10px',
                        }} />
                    </span>
                </span>
        );
    }
}

const mapStateToProps = (state: any) => ({
    organizationSettings: state?.organizations?.organizationSettings,
});

export default connect(mapStateToProps, null)(withStyles(styles as any)(ImgPlaceholder as any));